import { useCallback, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import InfiniteScroll from 'react-infinite-scroll-component'
import DotsLoading from 'components/loadings/dotsLoading'
import { PulseCard } from 'components/states'
import { TDecidedSort } from 'services/loans'
import useGetRejectedDemandLoans from '../../hooks/useGetRejectedDemandLoans'
import ClosedDemandCard from '../../components/ClosedDemandCard'
import DecidedSort from '../../components/DecidedSort'

export default function Rejected() {
    const { id } = useParams()
    const [sort, setSort] = useState<TDecidedSort>('decided_newest')
    const { demandLoans, isLoadingDemandLoans, fetchNextPage } =
        useGetRejectedDemandLoans(id, sort)
    const onWatchEnd = useCallback(() => {
        fetchNextPage()
    }, [fetchNextPage])
    const rows = useMemo(
        () => demandLoans?.pages.flatMap((page) => page.results) ?? [],
        [demandLoans]
    )
    const hasMore = Boolean(
        demandLoans?.pages[demandLoans.pages.length - 1]?.next
    )

    return (
        <div className=" pb-6">
            <DecidedSort sort={sort} onChange={setSort} tab="rejected" />
            {isLoadingDemandLoans || !demandLoans ? (
                <div className=" mt-3 flex flex-col gap-3">
                    <PulseCard />
                    <PulseCard />
                </div>
            ) : (
                <div className=" pt-3">
                    {rows.length === 0 && (
                        <p className=" rounded-2xl border border-stroke bg-white p-6 text-center text-xs leading-6 text-text-secondary">
                            درخواست رد یا لغوشده‌ای نیست.
                        </p>
                    )}
                    <InfiniteScroll
                        next={onWatchEnd}
                        hasMore={hasMore}
                        dataLength={rows.length}
                        loader={<DotsLoading />}
                        style={{ overflow: 'visible' }}
                    >
                        <div className=" flex flex-col gap-3">
                            {rows.map((item) => (
                                <ClosedDemandCard key={item.id} item={item} />
                            ))}
                        </div>
                    </InfiniteScroll>
                </div>
            )}
        </div>
    )
}
